import React from "react";
import {createUseStyles, useTheme} from "react-jss";
import classNames from "classnames";
import { globalTheme } from "../../styles/globalTheme";

const Whitebutton = (props) => {
  const {   children, disabled, name, value, onClick, fake, className } = props;
  const theme = useTheme();
  const classes = useStyles({props, theme});

  return(
  fake ? (
    <div className={classNames(classes.button, className)}>{children}</div>
  ) : (
    <button
      type="button"
      disabled={disabled === true ? disabled : false}
      name={name ? name : ""}
      className={classNames(classes.button, className)}
      value={value ? value : ""}
      onClick={disabled === true ? () => {} : onClick}
    >
      {children}
    </button>
  ))
};

const useStyles = createUseStyles((theme) => ({
  button: {
    padding: ({ props }) => (props.padding ? props.padding : "6px 16px"),
    fontSize: ({ props }) => (props.fontSize ? props.fontSize : "14px"),
    borderRadius: "4px",
    border: ({ props }) =>
      `solid ${props.borderWidth ? props.borderWidth : "1px"} ${
        theme.actionButtonColor
      }`, //"solid 1px #335cda",
    backgroundColor: "#ffffff",
    color: theme.actionButtonColor, //"#335cda",
    display: "flex",
    alignItems: "center",
    "&:enabled:hover": {
      borderColor: theme.menuDarkColor, //"solid 1px #182d58",
      color: theme.menuDarkColor, //"#182d58",
      "& svg path": {
        fill: `${theme.menuDarkColor} !important`, //"#182d58!important",
      },
    },
    "&:focus": {
      outline: ({ props }) => (props.noFocus ? null : globalTheme.outline),
    },
  },
}));

export default Whitebutton;
